import type { ComponentType, SVGProps } from "react";
import { MobileIcon } from "../booking/booking-icons";
import {
  CategoriesIcon,
  DashboardIcon,
  FigmaIcon,
  PenNibIcon,
  TableIcon,
} from "./works-icons";

export type WorkCategoryId =
  | "all"
  | "webapps"
  | "mobileapp"
  | "dashboards";

/** Filter pills, in the order the design lays them out (start → end). */
export const WORK_CATEGORIES: {
  id: WorkCategoryId;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}[] = [
  { id: "all", icon: CategoriesIcon },
  { id: "webapps", icon: TableIcon },
  { id: "mobileapp", icon: MobileIcon },
  { id: "dashboards", icon: DashboardIcon },
];

export const DEFAULT_CATEGORY: WorkCategoryId = "all";

export type WorkProject = {
  /** Index into the `Works.projects` messages array. */
  index: number;
  category: Exclude<WorkCategoryId, "all">;
  /** Cover image; `null` renders the neutral placeholder used in the design. */
  image: string | null;
  /** Locale-relative case study path, or an absolute URL containing `{locale}`. */
  href: string;
};

/** Real portfolio entries. `href` is a locale-relative case study path. */
export const WORK_PROJECTS: WorkProject[] = [
  { index: 0, category: "mobileapp",   image: "/assets/images/works/oustadhi.jpg",               href: "/works/oustadhi" },
  { index: 1, category: "mobileapp",   image: "/assets/images/works/waseet.jpg",                 href: "/works/waseet" },
  { index: 2, category: "mobileapp",   image: "/assets/images/works/sharwa.jpg",                 href: "/works/sharwa" },
  { index: 3, category: "mobileapp",   image: "/assets/images/works/my-library.jpg",             href: "/works/my-library" },
  { index: 4, category: "dashboards",  image: "/assets/images/works/sapetrol.jpg",               href: "/works/sapetrol" },
  { index: 5, category: "mobileapp",   image: "/assets/images/works/visit-syria.jpg",            href: "/works/visit-syria" },
  { index: 6, category: "mobileapp",   image: "/assets/images/works/fitness.jpg",                href: "/works/fitness" },
  { index: 7, category: "webapps",     image: "/assets/images/works/bothour-tech.jpg",         href: "/works/bothour-tech" },
  { index: 8, category: "mobileapp",   image: "/assets/images/works/sanad.jpg",                href: "/works/sanad" },
  { index: 9, category: "webapps",     image: "/assets/images/works/family-tree.jpg",          href: "/works/family-tree" },
  { index: 10, category: "mobileapp",   image: "/assets/images/works/taha.jpg",                 href: "/works/taha" },
  { index: 11, category: "webapps",     image: "/assets/images/works/easy-control.jpg",         href: "/works/easy-control" },
  { index: 12, category: "webapps",     image: "/assets/images/works/eqraa-sports.jpg",         href: "/works/eqraa-sports" },
  { index: 13, category: "mobileapp",   image: "/assets/images/works/nefaah.jpg",               href: "/works/nefaah" },
  { index: 14, category: "mobileapp",   image: "/assets/images/works/taxi.jpg",                 href: "/works/taxi" },
  { index: 15, category: "mobileapp",   image: "/assets/images/works/car-wash.jpg",             href: "/works/car-wash" },
];

/** The three shown in the home page teaser, in this order. */
export const FEATURED_SLUGS = ["my-library", "sharwa", "oustadhi"] as const;

export const FEATURED_PROJECTS: WorkProject[] = FEATURED_SLUGS.map((slug) => {
  const project = WORK_PROJECTS.find((entry) => entry.href === `/works/${slug}`);
  if (!project) throw new Error(`FEATURED_SLUGS: no project for "${slug}"`);
  return project;
});
